import { Box } from "@mui/material";

import styled from "styled-components";

const BoxDivider = styled(Box)`
  border-bottom: 1px solid #0000001f;
  border-color: divider;
  margin-bottom: 10px;
`;

const temp = styled.div`
  color: white;
`;

export { BoxDivider, temp };
